.avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  overflow: hidden;
  border-radius: var(--cl-radius-round);
  color: var(--cl-white);
  font-weight: var(--cl-fw-regular);
  line-height: 1;
  user-select: none;
}

.square {
  border-radius: var(--cl-radius-nd);
}

.img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.srOnly {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}
